export const en = {
  // Common
  loading: "Loading...",
  back: "Back",
  cancel: "Cancel",
  submit: "Submit",
  create: "Create",
  delete: "Delete",
  edit: "Edit",
  save: "Save",
  confirm: "Confirm",
  logout: "Logout",
  login: "Login",
  optional: "Optional",
  deleting: "Deleting...",
  
  // Operating Ledger Delete
  deleteLedgerEntryTitle: "Delete Entry",
  deleteLedgerWarning: "This action cannot be undone. All related financial data will be updated.",
  entryType: "Type",
  documentNo: "Document No",
  amount: "Amount",
  voidReason: "Reason for Deletion",
  enterVoidReason: "Enter reason for deletion...",
  
  // Operating Ledger namespace
  operatingLedger: {
    deleteSuccess: "Entry deleted successfully",
    deleteError: "Failed to delete entry"
  },
  
  // Landing Page
  appTitle: "Building Management System",
  appSubtitle: "Streamline apartment management, track maintenance fees, monitor expenses, and keep residents informed.",
  signInGoogle: "Sign In with Google",
  signInManual: "Sign In with Username",
  apartmentManagement: "Apartment Management",
  apartmentManagementDesc: "Easily manage apartments and assign residents",
  feeTracking: "Fee Tracking",
  feeTrackingDesc: "Track maintenance fees and payment status",
  announcements: "Announcements",
  announcementsDesc: "Keep residents informed with updates",
  
  // PandaProp Landing Page
  landingLogoAlt: "PandaProp Logo",
  landingTitle: "PandaProp",
  landingSubtitle: "Complete Building & Apartment Management",
  landingDescription: "Manage apartments, dues, expenses, investments, other income, announcements, and financial reports — all in one multi-tenant platform.",
  landingPrimaryCta: "Sign In",
  landingLoginHint: "Use your assigned username and password",
  
  // Feature Cards
  featureApartments: "Apartment & Resident Management",
  featureApartmentsDesc: "Manage floors, units, and resident assignments with ease",
  featureDues: "Dues Tracking & Payments",
  featureDuesDesc: "Track paid/unpaid status with detailed monthly reports",
  featureExpenses: "Expense Management",
  featureExpensesDesc: "Categorize and track building expenses by type",
  featureInvestments: "Investment Tracking",
  featureInvestmentsDesc: "Monitor building projects and capital investments",
  featureOtherIncome: "Other Income",
  featureOtherIncomeDesc: "Track rental income, fees, and miscellaneous revenue",
  featureAnnouncements: "Announcements",
  featureAnnouncementsDesc: "Keep residents informed with building-wide updates",
  
  // Trust Bullets
  bulletMultiTenancy: "Building-based multi-tenancy",
  bulletAdminResident: "Admin & Resident portals",
  bulletMonthlyReports: "Monthly financial summary & detailed reports",
  
  // Login Form
  username: "Username",
  password: "Password",
  usernameRequired: "Username is required",
  passwordRequired: "Password is required",
  invalidCredentials: "Invalid username or password",
  
  // Dashboard
  adminDashboard: "Admin Dashboard",
  residentPortal: "Resident Portal",
  totalCollected: "Total Collected",
  totalUnpaid: "Total Unpaid",
  totalExpenses: "Total Expenses",
  viewOperatingLedger: "View Operating Ledger",
  close: "Close",
  
  // Operating Ledger
  operatingLedgerTitle: "Operating Ledger",
  selectMonthYear: "Select Month/Year",
  year: "Year",
  month: "Month",
  apply: "Apply",
  buildingName: "Building Name",
  ledgerRowNo: "No",
  ledgerDate: "Date",
  ledgerDocNo: "Doc No",
  ledgerInvoiceNo: "Invoice No",
  ledgerInvoiceNoPlaceholder: "Enter invoice no",
  ledgerDescription: "Description",
  ledgerExpenses: "Expenses",
  ledgerGoodsPurchases: "Goods Purchases",
  ledgerPaidVAT: "Paid VAT",
  ledgerIncome: "Income",
  ledgerGoodsSales: "Goods Sales",
  ledgerCollectedVAT: "Collected VAT",
  ledgerBalance: "Balance",
  ledgerTotal: "Total",
  ledgerGrandTotal: "Grand Total",
  ledgerMaintenanceCollection: "Maintenance Collection",
  ledgerOtherIncome: "Other Income",
  ledgerNoRecords: "No records for this period",
  ledgerUnit: "Unit",
  ledgerDevirBanka: "Opening Balance (Bank Carryover)",
  
  // Bank Statement Upload
  loadBankStatement: "Load Bank Statement",
  bankStatementResults: "Bank Statement Analysis",
  uploadExcelFile: "Upload Excel file (.xls or .xlsx)",
  selectFile: "Select File",
  analyzing: "Analyzing...",
  aidatPayments: "Maintenance Fee Payments",
  otherPaymentsSection: "Other Payments (Janitor Compensation etc.)",
  expensesSection: "Expenses",
  unidentifiedTransactions: "Unidentified Transactions",
  totalAmount: "Total Amount",
  transactionCount: "Transaction Count",
  apartmentsFound: "Apartments Found",
  residentName: "Resident Name",
  periodLabel: "Period",
  noTransactionsFound: "No transactions found",
  parseError: "Could not read file",
  
  // Bank Statement - Unit Assignment & Posting
  assignUnit: "Assign Unit",
  selectUnit: "Select Unit",
  poolAccount: "Pool Account",
  postToOperatingLedger: "Post to Operating Ledger",
  confirmPostTitle: "Confirm Posting",
  confirmPostMessage: "Are you sure you want to post the selected transactions to the operating ledger?",
  posting: "Posting...",
  postingComplete: "Posting Complete",
  postingFailed: "Posting Failed",
  bankStatementPosted: "Bank statement posted successfully",
  transactionsProcessed: "Transactions Processed",
  assignedToUnits: "Assigned to Units",
  assignedToPool: "Assigned to Pool",
  expensesPosted: "Expenses Posted",
  failedTransactions: "Failed Transactions",
  
  // Bank Statements Page
  bankStatementsTitle: "Bank Statements",
  bankStatementsNav: "Bank Statements",
  uploadedStatements: "Uploaded Statements",
  noStatementsYet: "No bank statements uploaded yet",
  uploadNewStatement: "Upload New Statement",
  statementFilename: "Filename",
  statementUploadDate: "Upload Date",
  statementPostDate: "Post Date",
  statementStatus: "Status",
  statementUploaded: "Uploaded",
  statementPosted: "Posted",
  viewDetails: "Details",
  revertStatement: "Revert",
  deleteStatement: "Delete",
  revertConfirmTitle: "Revert Bank Statement",
  revertConfirmMessage: "Are you sure you want to revert this bank statement? This will delete ALL records created from this statement (expenses, payments, pool entries). This action cannot be undone.",
  revertInProgress: "Reverting...",
  revertSuccess: "Bank statement reverted successfully",
  revertFailed: "Revert failed",
  deleteConfirmTitle: "Delete Bank Statement",
  deleteConfirmMessage: "Are you sure you want to delete this bank statement? You will need to re-upload the file if you want to use it again.",
  deleteSuccess: "Bank statement deleted",
  expensesRemoved: "Expenses Removed",
  paymentsRemoved: "Payments Removed",
  poolEntriesRemoved: "Pool Entries Removed",
  feesRecalculated: "Fees Recalculated",
  
  // Maintenance Payment Edit
  editMaintenancePayment: "Edit Maintenance Payment",
  currentUnit: "Current Unit",
  period: "Period",
  assignToUnit: "Assign to Unit",
  updateSuccess: "Updated successfully",
  paymentReassigned: "Payment reassigned",
  sameUnitSelected: "Same unit selected - no change needed",
  
  // Pool Income
  poolIncome: "Pool Account Income",
  poolIncomeDetails: "Pool Income Details",
  poolIncomeNote: "Pool income entries are managed through Bank Statements. To modify, revert the bank statement and re-import.",
  assignPoolToUnit: "Assign Pool Income to Unit",
  poolAssignmentNote: "This will apply the payment to the selected unit's oldest unpaid maintenance fees automatically.",
  assignAndApply: "Assign & Apply",
  feesUpdated: "fees updated",
  processing: "Processing...",
  otherPayment: "Other Payment",
  
  // Document Status
  documentStatusActive: "Active",
  documentStatusVoid: "Void",
  documentStatusReversal: "Reversal",
  voidReason: "Void Reason",
  reversalOf: "Reversal of",
  reversedBy: "Reversed by",
  voidConfirmTitle: "Void Record",
  voidConfirmMessage: "Are you sure you want to void this record? This action cannot be undone and a reversal entry will be created.",
  voidReasonPlaceholder: "Enter void reason...",
  voidSuccess: "Record voided successfully",
  
  // Edit Expense/Income
  editExpense: "Edit Expense",
  expenseUpdated: "Expense updated successfully",
  documentNoImmutable: "cannot be changed",
  
  // Past month expense warning
  pastMonthExpenseTitle: "Past Month Expense",
  pastMonthExpenseMessage: "The selected date belongs to a previous month. This expense will appear in the ledger for that month, not the currently selected month. Do you want to continue?",
  pastMonthExpenseCancel: "Cancel",
  pastMonthExpenseContinue: "Continue",
  
  apartments: "Apartments",
  outstandingBalance: "Outstanding Balance",
  totalPaid: "Total Paid",
  
  // Navigation
  maintenanceFees: "Maintenance Fees",
  expenses: "Expenses",
  expenseReports: "Expense Reports",
  manageApartments: "Manage apartments and residents",
  trackPayments: "Track and manage payments",
  recordExpenses: "Record building expenses",
  postUpdates: "Post updates for residents",
  viewUpdates: "View building updates",
  seeExpenses: "See how fees are spent",
  
  // Sample Data
  generateSampleData: "Generate Sample Data",
  generateSampleDataDesc: "Create test data for demo",
  clearSampleData: "Clear Sample Data",
  clearSampleDataDesc: "Remove all test data",
  sampleDataGenerated: "Sample data generated",
  sampleDataCleared: "Sample data cleared",
  
  // Apartments
  newApartment: "+ New Apartment",
  unitNumber: "Unit Number",
  floor: "Floor",
  resident: "Resident",
  residents: "Residents",
  assignResident: "Assign resident...",
  ownerLabel: "Owner",
  tenantLabel: "Tenant",
  selectOwner: "Select owner...",
  selectTenantOptional: "Select tenant (optional)...",
  ownerOccupied: "Owner-occupied",
  tenantOccupied: "Tenant-occupied",
  ownerTenantHint: "Dues go to the tenant, other payments go to the owner.",
  occupancyStatus: "Occupancy Status",
  ownerRequired: "An owner must be selected.",
  tenantRequired: "A tenant must be selected for a tenant-occupied apartment.",
  samePersonError: "Owner and tenant cannot be the same person. If the owner lives in the apartment, leave the tenant field empty and select 'Owner-occupied'.",
  assignmentSaved: "Assignment saved",
  tenantDebtReadOnly: "Tenant's debt (read-only)",
  tenantDuesReadOnly: "Tenant's dues (read-only)",
  selectUnit: "Select unit",
  totalAllUnits: "Total debt (all units)",
  yourDebtLabel: "Your debt",
  residentAssigned: "Resident assigned",
  apartmentCreated: "Apartment created",
  apartmentDeleted: "Apartment deleted",
  deleteApartment: "Delete this apartment?",
  noResident: "No resident",
  assigned: "Assigned",
  
  // Maintenance Fees
  newFee: "+ New Fee",
  amount: "Amount",
  month: "Month",
  year: "Year",
  status: "Status",
  actions: "Actions",
  period: "Period",
  generateYearlyFees: "Generate Yearly Fees",
  yearlyFeesGenerated: "Yearly fees generated successfully",
  allFeesAlreadyExist: "All fees already exist for this year",
  created: "created",
  skipped: "skipped",
  monthlyAmount: "Monthly Amount",
  selectApartment: "Select Apartment",
  all: "All",
  generate: "Generate",
  paid: "paid",
  unpaid: "unpaid",
  partiallyPaid: "partially paid",
  markPaid: "Mark Paid",
  markUnpaid: "Mark Unpaid",
  markedAsUnpaid: "Marked as unpaid",
  markedAsPaid: "Marked as paid",
  
  // Partial Payment System
  takePayment: "Take Payment",
  payInFull: "Pay in Full",
  partialPayment: "Partial Payment",
  paidAmount: "Paid Amount",
  remainingAmount: "Remaining",
  dueAmount: "Due Amount",
  aidatAmount: "Maintenance Fee",
  otherPaymentAmount: "Other Payment",
  paymentAmount: "Payment Amount",
  paymentMethod: "Payment Method",
  paymentNote: "Payment Note",
  paymentRecorded: "Payment recorded",
  cannotMarkUnpaidWithPayments: "Cannot mark as unpaid when there are active payment transactions",
  partialPaymentLabel: "Partial",
  paymentHistory: "Payment History",
  noPayments: "No payments yet",
  
  // Simplified Payment Actions
  markAsPaid: "Mark as Paid",
  undoPayment: "Undo",
  undoPaymentConfirm: "Are you sure you want to undo all payments for this period?",
  paymentUndone: "Payment(s) undone",
  confirmPayment: "Confirm Payment",
  paymentExceedsRemaining: "Payment amount cannot exceed remaining debt",
  paymentDateYearWarning: "Payment date must be within the selected year",
  noApartments: "No apartments found. Please add apartments first.",
  
  // Cumulative Balance System
  devirBakiyesi: "Opening Balance",
  cumulativeRemaining: "Remaining (Cumulative)",
  openingBalance: "Opening Balance",
  cumulativeBalance: "Cumulative Balance",
  
  // Initial Carryover System (one-time setup)
  initializeCarryover: "Initialize Opening Balance",
  initialCarryoverAmount: "Initial Carryover Amount",
  effectiveYear: "Effective Year",
  initializeCarryoverHelp: "Set the initial carryover balance for this apartment once. This amount will be used as the starting balance for the year tracking begins. Subsequent years will automatically derive their carryover from the previous year's closing balance.",
  carryoverInitialized: "Opening balance initialized successfully",
  carryoverAlreadySet: "Initial carryover already set for this apartment. It cannot be changed.",
  carryoverNotInitialized: "Opening balance not yet initialized",
  carryoverSourceInitial: "Initial amount",
  carryoverSourcePreviousYear: "Previous year closing balance",
  positiveIsDebt: "Positive = Debt, Negative = Credit",
  immutableWarning: "This action cannot be undone. Changes are not allowed.",
  
  // Summary Footer
  total: "TOTAL",
  totalDebt: "Total Debt",
  totalCredit: "Total Credit",
  balance: "Balance",
  balanceZero: "Balance Zero",
  cumulativeAsOfToday: "Cumulative for selected year as of today",
  monthNotStarted: "This month has not started yet",
  cannotCreateFutureFees: "Cannot create fees for future months",
  futureMonthsNotCreated: "future months not created",
  
  // Advance Payments
  advancePayment: "Advance Payment",
  advancePaymentInfo: "This payment will be processed as an advance for the selected month.",
  advancePaymentAllocated: "Advance payment allocated",
  advancePaymentDeleted: "Advance payment deleted",
  allocatePayment: "Allocate Payment",
  
  // Other Payments
  otherPayments: "Other Payments",
  addOtherPayment: "+ Other Payment",
  otherPaymentSchedule: "Other Payment Schedule",
  startMonth: "Start Month",
  durationMonths: "Duration (Months)",
  amountPerMonth: "Monthly Amount",
  paymentDescription: "Description",
  paymentDescriptionPlaceholder: "Enter payment description (e.g., Renovation costs, Elevator maintenance)",
  otherPaymentCreated: "Other payment schedule created",
  otherPaymentDeleted: "Other payment schedule deleted",
  otherPaymentCollection: "Other Payment Collection",
  selectMonth: "Select month...",
  
  feeCreated: "Fee created",
  feeDeleted: "Fee deleted",
  deleteFee: "Delete this fee?",
  apartment: "Apartment",
  selectApartment: "Select apartment...",
  
  // Expenses
  newExpense: "+ New Expense",
  addExpense: "+ Add Expense",
  category: "Category",
  subcategory: "Subcategory",
  date: "Date",
  description: "Description",
  expenseCreated: "Expense created",
  expenseDeleted: "Expense deleted",
  deleteExpense: "Delete this expense?",
  expenseDetails: "Expense Details",
  expenseReport: "Expense Report",
  grandTotalExpense: "Grand Total",
  noExpensesYet: "No expenses recorded yet",
  addFirstExpense: "to add your first expense",
  expenseDistribution: "Expense Distribution",
  noExpenseData: "No expense data to display",
  itemCount: "item",
  items: "items",
  collapseAll: "Collapse All",
  expandAll: "Expand All",
  categoryLabel: "Category",
  categoryPlaceholder: "Select a category",
  subcategoryLabel: "Subcategory",
  subcategoryPlaceholder: "Select a subcategory",
  categoryRequired: "Category is required",
  subcategoryRequired: "Subcategory is required",
  
  // Expense Categories
  expenseCategories: {
    commonArea: "Common Area & Operations",
    maintenance: "Maintenance & Repair",
    management: "Management & Operational",
    taxOfficial: "Tax & Official",
    insurance: "Insurance & Safety",
    other: "Other"
  },
  
  // Expense Subcategories
  expenseSubcategories: {
    commonArea: {
      cleaning: "Cleaning",
      security: "Security",
      janitor: "Janitor / Staff Salary",
      reception: "Reception / Concierge",
      gardening: "Gardening / Landscaping",
      elevatorMaintenance: "Elevator Maintenance & Service",
      generatorMaintenance: "Generator Maintenance",
      fireSystemsMaintenance: "Fire Systems Maintenance",
      poolMaintenance: "Pool Maintenance & Chemicals",
      commonElectricity: "Common Area Electricity",
      commonWater: "Common Area Water",
      naturalGas: "Natural Gas (Common Area)"
    },
    maintenance: {
      electricalRepair: "Electrical Repair",
      plumbingRepair: "Water / Plumbing Repair",
      elevatorBreakdown: "Elevator Breakdown",
      roofRepair: "Roof Repair",
      paintingRenovation: "Painting & Renovation",
      fixtureRepair: "Fixture / Asset Repair",
      emergencyRepairs: "Emergency Repairs"
    },
    management: {
      managerFee: "Manager Fee",
      accountingAdvisor: "Accounting / Financial Advisor",
      buildingManagementService: "Building Management Service",
      legal: "Legal / Lawyer",
      consultancy: "Consultancy",
      stationeryOffice: "Stationery & Office",
      softwareSystem: "Software / System"
    },
    taxOfficial: {
      taxes: "Taxes",
      municipalityFees: "Municipality Fees",
      licenseProcedures: "License & Official Procedures",
      penaltiesFees: "Penalties / Late Fees"
    },
    insurance: {
      buildingInsurance: "Building Insurance",
      assetInsurance: "Asset Insurance",
      occupationalHealth: "Occupational Health & Safety",
      fireExtinguisher: "Fire Extinguisher / Equipment"
    },
    other: {
      pestControl: "Pest Control",
      wasteManagement: "Garbage / Waste Management",
      snowRemoval: "Snow Removal / Seasonal",
      generalExpense: "General Expense",
      other: "Other"
    }
  },
  
  // Announcements
  newAnnouncement: "+ New Announcement",
  title: "Title",
  content: "Content",
  latestAnnouncements: "Latest Announcements",
  announcementCreated: "Announcement created",
  announcementDeleted: "Announcement deleted",
  deleteAnnouncement: "Delete this announcement?",
  noAnnouncements: "No announcements yet.",
  
  // Announcement Attachments
  attachments: "Attachments",
  addAttachment: "Add File",
  fileUploaded: "File uploaded",
  uploadFailed: "Failed to upload file",
  fileTooLarge: "File is too large. Max 10MB allowed.",
  attachmentRemoved: "Attachment removed",
  removeFailed: "Failed to remove attachment",
  downloadFailed: "Failed to download file",
  allowedFileTypes: "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, GIF, TXT (max 10MB)",
  uploading: "Uploading...",
  creating: "Creating...",
  
  // Settings
  settings: "Settings",
  language: "Language",
  currency: "Currency",
  settingsUpdated: "Settings updated",
  personalLanguageSetting: "Personal language preference",
  systemCurrencySuperAdmin: "System-wide currency setting",
  systemCurrencyReadOnly: "System-wide currency (SuperAdmin only)",
  onlySuperAdminCanChangeCurrency: "Only SuperAdmin can change currency",
  noChangesToSave: "No changes to save",
  
  // Languages
  english: "English",
  turkish: "Turkish",
  azerbaijani: "Azerbaijani",
  
  // Users
  users: "Users",
  newUser: "+ New User",
  name: "Name",
  email: "Email",
  phone: "Phone",
  role: "Role",
  admin: "Admin",
  residentRole: "Resident",
  userCreated: "User created",
  userUpdated: "User updated",
  editUser: "Edit User",
  resetPassword: "Reset Password",
  resetPasswordFor: "Reset password for",
  newPassword: "New Password",
  enterNewPassword: "Enter new password",
  passwordMinLength: "Password must be at least 6 characters",
  passwordResetSuccess: "Password reset successfully",
  authType: "Auth Type",
  usernameExists: "Username already exists",
  emailOptional: "Email (optional)",
  phoneOptional: "Phone (optional)",
  actions: "Actions",
  apartmentNo: "Apartment No",
  noApartment: "No apartment",
  apartmentRequired: "Apartment is required",
  apartmentRequiredForResident: "Apartment is required for resident users",
  selectApartment: "Select apartment",
  apartment: "Apartment",
  optional: "Optional",
  
  // SuperAdmin Building Selection
  selectBuilding: "Select Building",
  selectedBuilding: "Selected Building",
  viewingAsAdmin: "Viewing as Admin",
  noBuildingSelected: "No building selected",
  viewAdminPanel: "View Admin Panel",
  backToSuperAdmin: "Back to SuperAdmin",
  managingBuilding: "Managing Building",
  
  // Errors
  operationFailed: "Operation failed",
  loadDataFailed: "Failed to load data",
  authenticationFailed: "Authentication failed",
  
  // Misc
  count: "Count",
  totalItems: "Total Items",
  manageUsers: "Manage users",
  
  // Months
  months: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  },

  // Resident Portal
  maintenanceStatus: "Maintenance Status",
  lastSixMonths: "Last 6 Months",
  paymentReport: "Payment Report",
  unpaidBalance: "Unpaid Balance",
  totalPaidLabel: "Total Paid",
  totalUnpaidMonths: "Total Unpaid Months",
  unpaidMonthsCount: "Unpaid Months Count",
  lastFeeAmount: "Last Fee Amount",
  feeAmount: "Fee Amount",
  payMaintenance: "Pay Maintenance",
  viewReportAndPay: "View Report and Pay",
  monthTotal: "Month Total",
  monthShort: {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec"
  },
  recentAnnouncements: "Recent Announcements",
  monthlyExpenses: "Monthly Expenses",
  monthlySummary: "Monthly Financial Summary",
  carryover: "Carryover",
  carryoverFromPrevMonth: "From Previous Month",
  income: "Income",
  expenses: "Expenses",
  balance: "Balance",
  viewDetailedReport: "View Detailed Report",
  year: "Year",
  totalIncome: "Total Income",
  totalExpense: "Total Expense",
  netBalance: "Net Balance",
  viewReports: "View Reports",
  investments: "Investments",
  completed: "Completed",
  inProgress: "In Progress",
  planned: "Planned",
  newInvestment: "+ New Investment",
  investmentCreated: "Investment created",
  investmentDeleted: "Investment deleted",
  deleteInvestment: "Delete this investment?",
  noInvestmentsYet: "No investments recorded yet",
  startDate: "Start Date",
  completedDate: "Completed Date",
  endDate: "End Date",
  investmentCategoryLabel: "Investment Category",
  investmentCategoryPlaceholder: "Select investment category",
  investmentSubcategoryLabel: "Investment Subcategory",
  investmentSubcategoryPlaceholder: "Select investment subcategory",
  investmentCategoryRequired: "Investment category is required",
  investmentSubcategoryRequired: "Investment subcategory is required",
  descriptionRequired: "Description is required",
  endDateBeforeStartDate: "End date cannot be before start date",
  startDateRequired: "Start date is required",
  
  // Investment Categories
  investmentCategories: {
    physical: "Physical / Structural Investments",
    energy: "Energy & Efficiency Investments",
    security: "Security & Technology",
    social: "Social Areas & Comfort",
    legal: "Project & Legal Investments"
  },
  
  // Investment Subcategories
  investmentSubcategories: {
    physical: {
      elevatorRenovation: "Elevator Renovation",
      roofRenovation: "Roof Renovation / Insulation",
      exteriorInsulation: "Exterior Insulation (Facade)",
      parkingConstruction: "Parking Area Construction / Improvement",
      earthquakeReinforcement: "Earthquake Reinforcement",
      fireSystemInstallation: "Fire System Installation",
      waterTankRenovation: "Water Tank Renovation",
      generatorInstallation: "Generator Installation"
    },
    energy: {
      solarPanels: "Solar Panels (PV / GES)",
      heatPump: "Heat Pump",
      ledConversion: "Common Area LED Conversion",
      smartMeterSystems: "Smart Meter Systems",
      insulationImprovements: "Insulation Improvements"
    },
    security: {
      cameraSystem: "Camera System (CCTV)",
      accessCardSystem: "Access Card System",
      smartBuildingInfrastructure: "Smart Building Infrastructure",
      intercomRenovation: "Intercom / Door Phone Renovation",
      buildingManagementSoftware: "Building Management Software (Initial Setup)"
    },
    social: {
      childrensPlayground: "Children's Playground",
      sportsAreaFitness: "Sports Area / Fitness",
      landscapingRenovation: "Landscaping Renovation (One-time)",
      pergolaSeatingAreas: "Pergola / Gazebo / Seating Areas",
      commonAreaDecoration: "Common Area Decoration Projects"
    },
    legal: {
      architecturalDesign: "Architectural Design Project",
      structuralProject: "Structural (Static) Project",
      municipalityPermit: "Municipality / Permit-Based Project Costs",
      condominiumTransition: "Condominium Ownership Transition Works"
    }
  },
  manageInvestments: "Manage building projects",
  
  // Other Income
  otherIncome: "Other Income",
  otherIncomeTitle: "Other Income Management",
  manageOtherIncome: "Manage additional income sources",
  newOtherIncome: "New Other Income",
  addIncome: "+ Add Income",
  addMaintenancePayment: "+ Add Payment",
  manualPaymentTitle: "Manual Maintenance Payment",
  manualPaymentDescription: "Enter maintenance payment manually without bank statement",
  selectApartment: "Select Apartment",
  poolAccount: "Pool Account",
  paymentAmount: "Payment Amount",
  paymentDate: "Payment Date",
  paymentDescription: "Description (Optional)",
  manualPaymentSuccess: "Payment recorded successfully",
  manualPaymentError: "Error recording payment",
  processingPayment: "Processing...",
  feesApplied: "fees applied",
  remainingAsCredit: "remaining as credit balance",
  category: "Category",
  description: "Description",
  amount: "Amount",
  date: "Date",
  otherIncomeCreated: "Other income record created successfully",
  otherIncomeUpdated: "Other income record updated successfully",
  otherIncomeDeleted: "Other income record deleted successfully",
  editOtherIncome: "Edit Other Income",
  deleteOtherIncome: "Delete Other Income",
  confirmDeleteOtherIncome: "Are you sure you want to delete this income record?",
  
  // Other Income Categories
  incomeCategory: "Income Category",
  commonAreaRental: "Common Area Rental",
  parkingFees: "Parking Fees",
  facilityUsageFees: "Facility Usage Fees",
  penalties: "Penalties / Compensation",
  keyCardFees: "Key / Card / Fob Fees",
  otherCategory: "Other",
  
  // Financial Reports
  incomeBreakdown: "Income Breakdown",
  expenseBreakdown: "Expense Breakdown",
  maintenanceFeeIncome: "Maintenance Fees",
  latePaymentFees: "Late Payment Fees",
  otherIncomeTotal: "Other Income",
  regularExpenses: "Regular Expenses",
  investmentsTotal: "Investments",
  totalIncome: "Total Income",
  netBalance: "Net Balance",
  incomeExpenseReport: "Income & Expense Report",
  viewDetailedReport: "View Detailed Report",
  
  // Detailed Report Modal - New Keys
  detailedReportTitle: "Monthly Financial Report",
  incomeSectionTitle: "Income Details",
  aidatIncomeLabel: "Maintenance Fee Income",
  aidatIncomeNote: "From paid dues this month",
  assignedAidatIncomeLabel: "Assigned Maintenance Fee Income",
  assignedAidatIncomeNote: "Payments assigned to specific apartments",
  pendingPoolIncomeLabel: "Pending Pool Income",
  pendingPoolIncomeNote: "Payments not yet assigned to any apartment",
  otherPaymentIncomeLabel: "Other Payment Income",
  otherPaymentIncomeNote: "Doorman compensation and other apartment payments",
  otherIncomeSectionTitle: "Other Income",
  otherIncomeTotalLabel: "Other Income Total",
  expensesSectionTitle: "Expense Details",
  expenseItemsSectionTitle: "Expenses",
  expensesTotalLabel: "Expenses Total",
  investmentsSectionTitle: "Investments",
  investmentsTotalLabel: "Investments Total",
  noIncomeThisMonth: "No income recorded this month",
  noOtherIncomeThisMonth: "No other income this month",
  noExpensesThisMonth: "No expenses recorded this month",
  noInvestmentsThisMonth: "No investments this month",
  
  // Print
  print: "Print",
  
  // SuperAdmin & Buildings
  superAdminPortal: "SuperAdmin Portal",
  buildings: "Buildings",
  buildingManagement: "Building Management",
  createBuilding: "Create New Building",
  editBuilding: "Edit Building",
  buildingName: "Building Name",
  buildingAddress: "Building Address",
  numberOfFloors: "Number of Floors",
  numberOfApartments: "Total Apartments",
  buildingAdmin: "Building Admin",
  adminFullName: "Admin Full Name",
  adminUsername: "Admin Username",
  adminPassword: "Admin Password",
  adminPhone: "Admin Phone",
  adminEmail: "Admin Email",
  buildingCreated: "Building created successfully",
  buildingUpdated: "Building updated successfully",
  buildingDeleted: "Building deleted successfully",
  viewBuilding: "View Building",
  deleteBuilding: "Delete Building",
  confirmDeleteBuilding: "Are you sure you want to delete this building?",
  buildingDetails: "Building Details",
  manageBuildings: "Manage buildings and administrators",
  noBuildings: "No buildings yet",
  leaveBlankToKeep: "Leave blank to keep current",
  
  // Change Password
  changePassword: "Change Password",
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  passwordChangedSuccess: "Your password has been successfully changed",
  currentPasswordIncorrect: "Current password is incorrect",
  passwordsDoNotMatch: "Passwords do not match",
  passwordTooWeak: "Password must be at least 6 characters",
  newPasswordSameAsOld: "New password must be different from current password",
  enterCurrentPassword: "Enter your current password",
  enterNewPassword: "Enter your new password",
  confirmPassword: "Confirm your new password",
  passwordChangeError: "Failed to change password. Please try again.",
  
  // Payment Status Modal
  paymentStatusTitle: "Maintenance Payment Status",
  previousYearBalance: "Previous Year Balance",
  carryOverDebt: (year) => `Carry-over debt from ${year}`,
  payUnpaidFees: "Pay Unpaid Fees",
  paySelectedUnpaidFees: "Pay Selected Unpaid Fees",
  devir: "Opening Balance",
  devirDesc: "Carried over from previous year",
  partiallyPaid: "Partially Paid",
  paidAmount: "Paid",
  remainingAmount: "Remaining",
  otherPaymentLabel: "Other Payment",
  cumulativeBalance: "Cumulative Remaining",
  collapseYear: "Collapse year",
  expandYear: "Expand year",
  paymentDate: "Payment Date",
  selectPaymentDate: "Select Payment Date",
  noFeesFound: "No maintenance fee records found yet.",
  paymentSummaryTitle: "Payment Summary",
  paymentSummaryDescription: "Review selected fees before confirming payment",
  confirmPayment: "Confirm Payment",
  cancelPayment: "Cancel",
  selectedTotal: "Selected Total",
  monthsToPay: "Months to Pay",
  totalAidat: "Total Maintenance Fee",
  totalOtherPayment: "Total Other Payment",
  totalPaid: "Total Paid",
  totalRemaining: "Total Remaining",
  makePayment: "Make Payment",
  paymentAmountLabel: "Payment Amount",
  paymentAmountExceedsDebt: "Payment amount cannot exceed total debt",
  paymentAmountMustBePositive: "Payment amount must be positive",
  totalDebt: "Total Debt",
  maintenanceFee: "Maintenance Fee",
  otherPaymentCol: "Other Payment",
  paidAmountCol: "Paid",
  remainingCumulative: "Remaining (Cum.)",
  yearSummary: "Year Summary",
  
  // Bank Statement Name Matching
  matchStatistics: "Match Statistics",
  byUnitNumber: "By Unit No",
  byFullName: "By Full Name",
  bySimilarName: "By Similar Name",
  needsReview: "Needs Review",
  dataConflicts: "Data Conflicts",
  matchType: "Match Type",
  matchedByUnitNumber: "Matched by unit number",
  matchedByFullName: "Matched by full name",
  matchedBySimilarName: "Matched by similar name",
  lowConfidence: "Low Confidence",

  // WhatsApp Templates
  waTemplateDuesReminder: "Dues Reminder",
  waTemplateDuesReminderDesc: "Notify residents about unpaid dues",
  waTemplateDuesReminderBody: "Dear {{residentName}}, your unpaid dues balance for apartment {{apartmentNumber}} is {{amount}}. Please complete your payment.",
  waTemplateAnnouncementGeneral: "General Announcement",
  waTemplateAnnouncementGeneralDesc: "Send general building announcements",
  waTemplateAnnouncementGeneralBody: "New announcement: {{announcementText}}",
  waTemplateVarResidentName: "Resident Name",
  waTemplateVarApartmentNumber: "Apartment Number",
  waTemplateVarAmount: "Amount",
  waTemplateVarAnnouncementText: "Announcement Text",
  waPageTitle: "WhatsApp",
  waPageSubtitle: "Send notifications to residents",
  waSendTab: "Send Message",
  waLogTab: "Message Log",
  waTemplatesTab: "Templates",
  waTemplateMode: "Template",
  waTextMode: "Free Text",
  waRecipientPhone: "Recipient Phone",
  waMessageBody: "Message",
  waTextPlaceholder: "Type your message...",
  waSelectTemplate: "Template",
  waLanguage: "Language",
  waVariables: "Variables",
  waPreview: "Preview",
  waSendBtn: "Send WhatsApp Message",
  waSending: "Sending...",
  waPhoneRequired: "Phone number is required",
  waMessageRequired: "Message is required",
  waFillAllVars: "Please fill all template variables",
  waMessageSent: "Message sent",
  waTemplateSent: "Template message sent",
  waError: "Error",
  waTextWarning: "Free text messages only work if the recipient has messaged your business in the last 24 hours. Use templates for first-time messages.",
  waResidents: "Residents with Phone",
  waNoResidents: "No residents with phone numbers found",
  waNoMessages: "No messages sent yet",
  waDate: "Date",
  waRecipient: "Recipient",
  waType: "Type",
  waContent: "Content",
  waStatus: "Status",
  waSentBy: "Sent By",
  waNavDesc: "Send notifications"
};
